module.exports = __webpack_public_path__ + "static/marca-f570272295da0d6c31388af08c6cf829.svg";